export enum RulerFactoryOption {
    Start = 'START',
    End = 'END',
    Default = 'DEFAULT',
  }
  